import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';

export type InventoryReason =
  | 'CHECKOUT_RESERVE'
  | 'CHECKOUT_RELEASE'
  | 'POS_SALE'
  | 'RESTOCK'
  | 'MANUAL_ADJUST'
  | 'REFUND_RESTOCK';

export type InventorySource = 'APP' | 'IN_STORE' | 'BO' | 'SYNC_REGISTRATORE';

export interface InventoryMovementDto {
  id: string;
  productSizeId: string;
  delta: number;
  reason: InventoryReason;
  source: InventorySource;
  refOrderId: string | null;
  refExternalId: string | null;
  notes: string | null;
  createdAt: string;
  createdBy: string | null;
}

export interface PaginatedMovements {
  data: InventoryMovementDto[];
  meta: { total: number; page: number; limit: number; totalPages: number };
}

export interface MovementsFilters {
  page?: number;
  limit?: number;
  source?: InventorySource;
  reason?: InventoryReason;
  productSizeId?: string;
  from?: string;
  to?: string;
}

export function useInventoryMovements(filters: MovementsFilters = {}) {
  return useQuery({
    queryKey: ['inventory', 'movements', filters] as const,
    queryFn: async () => {
      const params: Record<string, string | number> = {};
      if (filters.page) params.page = filters.page;
      if (filters.limit) params.limit = filters.limit;
      if (filters.source) params.source = filters.source;
      if (filters.reason) params.reason = filters.reason;
      if (filters.productSizeId) params.productSizeId = filters.productSizeId;
      if (filters.from) params.from = filters.from;
      if (filters.to) params.to = filters.to;
      const res = await apiClient.get<PaginatedMovements>('/inventory/movements', {
        params,
      });
      return res.data;
    },
  });
}
